import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { useDocumentTitle } from "../lib/use-document-title";
import { Button } from "../components/ui";

export function NotFound() {
  useDocumentTitle("ページが見つかりません");
  return (
    <section class="mx-auto flex max-w-md flex-col items-center gap-4 py-16 text-center">
      <div class="text-sm font-semibold tracking-widest text-fg-faint uppercase">
        404
      </div>
      <h2 class="text-2xl font-semibold tracking-tight text-fg">
        ページが見つかりません
      </h2>
      <p class="text-sm text-fg-muted">
        URL が間違っているか、コンテンツが移動・削除された可能性があります。
      </p>
      <Button
        as="a"
        href="/"
        variant="secondary"
        class="mt-2"
        iconLeft={<ArrowLeftIcon class="h-4 w-4" />}
      >
        トップへ戻る
      </Button>
    </section>
  );
}
